var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharacterExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "character-exclamation-mark",
    fill: "none",
    "data-category": "ui",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--fg-color, #2A2859)",
    d: "m14.5 7 .4 12h2.2l.4-12h-3Zm-.501 16c0 1.119.857 2 2 2s2-.881 2-2c0-1.12-.857-2-2-2s-2 .88-2 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterExclamationMark);
export default __webpack_public_path__ + "static/media/character-exclamation-mark.6f9b5e05690fb3311f3d1b073f2c4be1.svg";
export { ForwardRef as ReactComponent };